import CommonAnalysisCard from "../../../../../VirtualPortfolioPage/components/AnalysisCard";
import React from "react";
import {withStyles} from "@material-ui/core";
import styles from "./styles";
import { isDateDifferenceEqualOrBiggerThanYear, toShortGermanFormat } from "../../../../utils";
import HighChartBase from "../../../../../../components/Charts/Base";
import {FactSheetsHandlerResource} from "../../../../../../utils/api";
import moment from "moment";
import {processResponse} from "../../../../index";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getInstrName } from '../../../../../Modelportfolios/utils';
import {DEFAULT_EMPTY_SECTION_MESSAGE} from "../../../../../../utils/constants";

class RollingVolatilityChart extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      dataProvider: FactSheetsHandlerResource,

      riskMetricsData: null,
      riskMetricsLoading: true,
      riskMetricsError: null,
      inceptionDate: props.assetInfo.inception_date,
    }

    this.fetchRollingVolatilityData = this.fetchRollingVolatilityData.bind(this);
  }

  componentDidMount() {
    if (isDateDifferenceEqualOrBiggerThanYear(this.state.inceptionDate)) {
      this.fetchRollingVolatilityData()
    } else {
      this.setState({
        riskMetricsLoading: false,
        riskMetricsError: true,
      })
    }
  }

  fetchRollingVolatilityData() {
      let dateStart = moment().subtract(1, 'years').format('YYYY-MM-DD');
      let dateEnd = moment().format('YYYY-MM-DD');
      processResponse(
          this.state.dataProvider.getAnalyseRiskMetricsRollingData(this.props.assetInfo.isin, dateStart, dateEnd),
          'rolling', 'riskMetrics', this
      )
  }

  renderChart() {
    const { classes } = this.props;
    const volaName = getInstrName(this.props.assetInfo);
    const portfolio_vol = this.state.riskMetricsData
      .filter(value => (value.volatility_annual !== undefined))
      .map(value => ([Date.parse(value.date), value.volatility_annual * 100]));

    const defaultChartColor = '#0596ce';
    const chartLegendStyle = {
      background: defaultChartColor
    };

    return <div className={classes.chartContainer}>
      <ul className={classes.legend}>
        <li className={classes.legendItem}>
          <div className={classes.bullet} style={chartLegendStyle} />
          <label>{volaName}</label>
        </li>
      </ul>
      <HighChartBase className={classes.chart} options={{
          title: {
            text: ''
          },
          credits: {
            enabled: false
          },
          data: {
            dateFormat: "YYYY-mm-dd"
          },
          series: [
            {
              type: 'line',
              name: volaName,
              color: defaultChartColor,
              data: portfolio_vol
            }
          ],
          chart: {
            type: 'line',
            height: 300,
            style: {
              fontFamily: "\"Roboto-Regular\", \"Lucida Sans Unicode\", Verdana, Arial, Helvetica, sans-serif",
              fontSize: 14
            }
          },
          rangeSelector: {
            enabled: false,
            allButtonsEnabled: false,
            inputEnabled: false,
            verticalAlign: 'top',
            buttons: null,
          },
          navigator: {
            enabled: false
          },
          legend: {
            enabled: false,
          },
          scrollbar: {
            enabled: false
          },
          plotOptions: {
            area: {
              fillColor: undefined
            },
            series: {
              animation: false,
              dataGrouping: {
                dateTimeLabelFormats: {
                  week: ["Woche vom %A, %b %e, %Y"],
                }
              },
              type: 'line',
              fillColor: undefined,
              compareBase: 0,
              showInNavigator: true,
            }
          },
          tooltip: {
            dateTimeLabelFormats: {
              day: "%b %e, %Y"
            },
            pointFormat: '<span><div style="display: inline-block; vertical-align: baseline; width: 10px; height: 10px; border-radius:50%; background-color: {series.color};" /><div style="display: inline; font-size: 14px; color: #80858C; margin-left: 15px;">{point.y} %</div></span><br/>',
            valueDecimals: 2,
            split: false,
            shared: true,
            backgroundColor: 'white',
            shadow: {
              color: '#00000026',
              offsetX: 0,
              offsetY: 0,
              width: 10,
              opacity: 0.15
            },
            padding: 20,
            useHTML: true,
            shape: 'square',
            borderWidth: 0,
            borderRadius: 4,
            headerFormat: '<span style="font-size: 14px; font-family: Roboto-Bold;">{point.key}</span><br/><br/>',
            style: {
              fontFamily: '"Roboto-Regular"'
            }
          },
          yAxis: {
            opposite: false,
            align: 'right',
            title: {
              enabled: false
            },
            labels: {
              enabled: true,
              align: 'right',
              formatter: function() {
                return toShortGermanFormat(this.value, '', ' %', 2, true);
              },
              style: {
                fontSize: 14
              }
            }
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              year: '%Y'
            },
            tickLength: 0,
            labels: {
              style: {
                fontSize: 14
              }
            }
          },
          responsive: {
            rules: [{
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                tooltip: {
                  positioner: function (labelWidth, labelHeight, point) {
                    return point.isHeader ? this.getPosition(labelWidth, labelHeight, point) : { x: 80, y: 30 };
                  }
                }
              }
            }]
          }
      }} language={'DE'}/>
    </div>
  }

  renderError() {
      return <div>{'Fehler. Die Graphik "Volatilitäs-Entwicklung" konnte nicht geladen werden.'}</div>
  }

  render() {
    const { classes } = this.props;

    return <CommonAnalysisCard
        classes={{
          card: classes.root
        }}
        title={'Rollierende 1-Jahres Volatilität-Entwicklung'}
        loading={this.state.riskMetricsLoading}
        content={
          <div className={classes.container}>
            {
              this.state.riskMetricsLoading ? <CircularProgress/> : this.state.riskMetricsError ? this.renderError() : this.state.riskMetricsData ? this.renderChart() : DEFAULT_EMPTY_SECTION_MESSAGE
            }
          </div>
      }
    />
  }
}

export default withStyles(styles)(RollingVolatilityChart)
